var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNeurobotBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 520,
    viewBox: "0 0 520 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2121 251.463C99.2121 168.621 166.369 101.464 249.212 101.464H270.788C353.631 101.464 420.788 168.621 420.788 251.464V253.659H440.514C443.828 253.659 446.514 256.345 446.514 259.659V304.335C446.544 290.351 458.051 279.025 472.24 279.025C486.448 279.025 497.966 290.381 497.966 304.391C497.966 318.4 486.448 329.756 472.24 329.756C458.051 329.756 446.544 318.43 446.514 304.446V349.122C446.514 352.436 443.828 355.122 440.514 355.122H420.788V370C420.788 452.843 353.631 520 270.788 520H249.212C166.369 520 99.2121 452.843 99.2121 370V355.122H79.4858C76.172 355.122 73.4858 352.436 73.4858 349.122V304.45C73.4533 318.432 61.9478 329.756 47.7598 329.756C33.5516 329.756 22.0337 318.4 22.0337 304.391C22.0337 290.381 33.5516 279.025 47.7598 279.025C61.9478 279.025 73.4533 290.349 73.4858 304.331V259.659C73.4858 256.345 76.172 253.659 79.4858 253.659H99.2121V251.463Z",
    fill: "#006AED"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.962,
    cy: 283.463,
    rx: 41.8048,
    ry: 41.2195,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.884 412.195C317.884 436.711 291.968 456.586 260 456.586C228.032 456.586 202.116 436.711 202.116 412.195C227.842 412.195 228.032 412.195 260 412.195C291.968 412.195 292.157 412.195 317.884 412.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.037,
    cy: 283.463,
    rx: 41.8049,
    ry: 41.2195,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.705,
    y: 63.4143,
    width: 38.5891,
    height: 63.4146,
    fill: "#006AED"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 260,
    cy: 38.0488,
    rx: 38.5891,
    ry: 38.0488,
    fill: "#006AED"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeurobotBg);
export default __webpack_public_path__ + "static/media/NeurobotBg.7ae26a356857591bee815ce501af0e8f.svg";
export { ForwardRef as ReactComponent };